import {isNil} from 'ramda';

import {VatRateOption} from '@dms/shared';

type CalculateCommonPriceReturnBody = {
  vatType: string;
  withVat: number;
  withoutVat: number;
  vat: number;
};

const DEFAULT_VAT_TYPE = 'S';

export const calculateCommonPrice = (
  defaultPriceWithoutVat: number,
  vatTypes: VatRateOption[]
): CalculateCommonPriceReturnBody => {
  const usedVatRate = vatTypes.find((vat) => vat.value === DEFAULT_VAT_TYPE);

  if (isNil(usedVatRate)) {
    throw new Error('RENTAL ORDER DEFAULT VALUE: VAT rate not found');
  }

  const rate = parseFloat(usedVatRate.rate);

  const withoutVat = defaultPriceWithoutVat;
  const withVat = withoutVat * (1 + rate / 100);
  const vat = withVat - withoutVat;

  return {
    vatType: DEFAULT_VAT_TYPE,
    withVat,
    withoutVat,
    vat,
  };
};
